import { Injectable } from '@angular/core'
import { BaseFilesConfigProvider, IFilesConfig } from '@engineering11/files-web'
import { Store } from '@ngrx/store'
import { getBaseSuffix } from 'shared-lib'
import { environment } from '../../environments/environment'
import { selectors } from '../store/selectors'

@Injectable({ providedIn: 'root' })
export class AdminFilesConfigProvider extends BaseFilesConfigProvider {
  constructor(private store: Store) {
    super()
  }
  get config(): IFilesConfig {
    return {
      filesBaseURL: environment.services.files,
      CNAME: environment.cdnCname,
      customerKey$: this.store.select(selectors.getCustomerKey$),
      token$: this.store.select(selectors.getToken),
      validationConfig: {},
      baseSuffix: getBaseSuffix(environment, 'files'),
    }
  }
}
